import * as React from "react";
import { Leaf, BadgeDollarSign, MapPin, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Identity Management",
  description: "Automated tenant-based identity with instant iMessage or Slack channel binding for seamless onboarding.",
  icon: Leaf,
  iconColor: "text-chart-2",
  link: "/OceanWalletPage"
}, {
  title: "Entitlements Engine",
  description: "Granular policy controls and workspace assignments powered by the OceanClaw surgical control plane.",
  icon: BadgeDollarSign,
  iconColor: "text-primary",
  link: "/OceanWalletPage"
}, {
  title: "Policy Routing",
  description: "Secure, routed access for private-thread commerce and follow-up work without technical friction.",
  icon: MapPin,
  iconColor: "text-chart-1",
  link: "/OceanWalletPage"
}];
export default function TheJunkDaddyDifference() {
  return <section data-section-id="225002" id="the-oceanclaw-infrastructure" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            The OceanClaw Infrastructure
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-mono text-sm tracking-widest text-chart-2 uppercase">
            Powered by OceanClaw — A surgical control plane for high-fidelity commerce.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-xl border border-white/10 bg-card/40 backdrop-blur-xl shadow-none transition-all duration-500 group-hover:border-chart-2/50 group-hover:bg-card/60">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[1.5] ${feature.iconColor} transition-transform duration-500 group-hover:scale-110`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-bold text-foreground tracking-tight">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center font-mono text-xs font-bold text-chart-2 opacity-0 transition-all duration-500 group-hover:translate-x-2 group-hover:opacity-100 uppercase tracking-widest">
                    Access Node <ArrowRight className="ml-2 size-4 stroke-[2]" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}